import { createRouter, createWebHistory } from 'vue-router'
import InboxView from '@/views/InboxView.vue'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/LoginView.vue')
        },
        {
            path: '/',
            redirect: '/inbox'
        },
        {
            path: '/inbox',
            name: 'inbox',
            component: InboxView
        },
        {
            path: '/pipeline',
            name: 'pipeline',
            component: () => import('@/views/PipelineView.vue')
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('@/views/DashboardView.vue')
        },
        {
            path: '/leads',
            name: 'leads',
            component: () => import('@/views/LeadsView.vue')
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('@/views/UsersView.vue')
        },
        {
            path: '/reports',
            name: 'reports',
            component: () => import('@/views/ReportsView.vue')
        },
        {
            path: '/profile',
            name: 'profile',
            component: () => import('@/views/ProfileView.vue')
        },
        {
            path: '/settings',
            name: 'settings',
            component: () => import('@/views/SettingsView.vue')
        },
        {
            path: '/admin/tools',
            name: 'admin-tools',
            component: () => import('@/views/AdminToolsView.vue'),
            meta: { requiresAdmin: true }
        }
    ]
})

router.beforeEach((to, from, next) => {
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('auth_token');

    if (authRequired && !loggedIn) {
        return next('/login');
    }

    next();
});

export default router
